export default __webpack_public_path__ + "static/media/tv.03e9e82c.svg";